import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider } from "@/lib/AuthContext";
import AppMain from "@/AppMain";
import AuthCallback from "@/components/AuthCallback";
import { PaymentSuccess, PaymentCancel } from "@/components/PaymentPages";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import RefundPolicy from "@/pages/RefundPolicy";
import About from "@/pages/About";
import WorthPage from "@/pages/WorthPage";
import CookieBanner from "@/components/CookieBanner";
import AdminPage from "@/pages/AdminPage";
import PartnerDashboard from "@/pages/PartnerDashboard";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Routes>
        <Route path="/" element={<AppMain />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/about" element={<About />} />
        <Route path="/worth/:slug" element={<WorthPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/partners/:code" element={<PartnerDashboard />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <CookieBanner />
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}
